module.exports = __webpack_public_path__ + "img/mobilis.5ca56fd5.svg";